import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
  getFiles,
  uploadFile,
  UploadFileProps,
} from '../../services/file-service'

export const fetchFilesAction = createAsyncThunk(
  'files/fetchFiles',
  async (data: { eventId; vendorId }) => {
    const { eventId, vendorId } = data
    return await getFiles(eventId, vendorId)
  },
)

export const uploadFileAction = createAsyncThunk(
  'files/uploadFile',
  async (data: UploadFileProps) => {
    return await uploadFile(data)
  },
)

const initialState = {
  fileList: null as null | undefined | any[], // only null until fetch files is called once
  isFetchingFiles: false,
}

const filesSlice = createSlice({
  name: 'files',
  initialState,
  reducers: {
    resetFilesAction: state => {
      state.fileList = []
      state.isFetchingFiles = false
    },
  },
  extraReducers: builder => {
    builder

      // fetchFilesAction
      .addCase(fetchFilesAction.pending, state => {
        state.isFetchingFiles = true
      })
      .addCase(fetchFilesAction.fulfilled, (state, action) => {
        state.isFetchingFiles = false
        state.fileList = action.payload.data
      })
      .addCase(fetchFilesAction.rejected, state => {
        state.isFetchingFiles = false
        state.fileList = []
      })

      // uploadFileAction
      .addCase(uploadFileAction.fulfilled, (state, action) => {
        // Create a new fileList array by looping through the current fileList
        const fileListWithUpdate = state?.fileList?.map(existingFile => {
          // Check if there is a new file that matches the existing file
          if (existingFile.fileKey === action.payload.fileKey) {
            // There was a match so update modified time
            return {
              ...existingFile,
              fileModifiedTime: action.payload.fileModifiedTime,
            }
          } else {
            // No match, return the existing file as is
            return existingFile
          }
        })

        state.fileList = fileListWithUpdate
      })
  },
})

export const { resetFilesAction } = filesSlice.actions

export default filesSlice.reducer
